export default defineNuxtRouteMiddleware((to, from) => {
  console.log(`Navigating to ${to.path} from ${from.path} with query:`, from.query);
  //PRESERVE QUERY PARAMS ON NAVIGATION
  if (from.query) {
    to.query = { ...from.query, ...to.query };
  }
});